import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, Container, UncontrolledTooltip } from 'reactstrap';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from 'components/Common/TableContainer';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { getUserListForCallAvailabilityAPIURL } from 'BaseComponentAPI/CallAvailability';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import Spinners from 'components/Common/Spinner';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import { checkPermissions } from 'components/Common/ChkPermissions';
import CantAccessPage from 'components/Common/CantAccessPage';

const CallAvailability = () => {
    const authUser = useSelector(state => state.Login);
    // console.log(JSON.stringify(authUser))

    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);
    // console.log(canRead)

    const navigate = useNavigate();

    document.title = "Cockpit";


    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
    const [popupType, setPopupType] = useState('');  // Set the type from passed state

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };


    const columns = useMemo(
        () => [
            {
                header: "User Name",
                accessorKey: "userName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "User Role",
                accessorKey: "userRole",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Department",
                accessorKey: "department",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Is Available For Calling",
                accessorKey: "isAvailableForCalling",
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ cell }) => (cell.getValue() === 1 ? "Yes" : "No"),
            },
            {
                header: "Is Live Access",
                accessorKey: "isLiveAccess",
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ cell }) => (cell.getValue() === 1 ? "Yes" : "No"),
            },
            {
                header: "Is System Access",
                accessorKey: "isSystemAccess",
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ cell }) => (cell.getValue() === 1 ? "Yes" : "No"),
            },
            {
                header: "Is Cold Call Access",
                accessorKey: "isColdCallAccess",
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ cell }) => (cell.getValue() === 1 ? "Yes" : "No"),
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: true,
                cell: cellProps => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(`/ChangeUserCallAvailability/${cellProps.row.original.userUUID}`);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                    aria-disabled={!canChange}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip
                                        placement="top"
                                        target={`edittooltip-${cellProps.row.original.id}`}
                                        timeout={150}
                                    >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>

                            </li>

                        </ul>
                    );
                },
            },
        ],
        []
    );


    const [data, setData] = useState([]);
    const [loaderOption, setLoaderOption] = useState(false);

    const [pageNo, setPageNo] = useState(1);  // Track the current page number
    const [pageSize, setPageSize] = useState(10);  // Track page size
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');
    const customePageSize = [10, 20, 30, 40, 50]

    useEffect(() => {
        if (!canRead) {
            openPopup('Something went wrong!', 'error')
        }
        else {
            getData();
        }

    }, [authUser]);

    const getData = async () => {
        setLoaderOption(true);
        setData([]);
        setTotalPages('');
        setTotalItems('');
        setNextPage('');
        setPreviousPage('');
        setCurrentPage('');
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            // console.log(JSON.stringify(authUser.headers))
            // console.log(`${getUserListForCallAvailabilityAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`)
            try {
                const response = await axios.get(
                    `${getUserListForCallAvailabilityAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg === "Success") {
                    setData(response.data.data.items);
                    setTotalPages(response.data.data.totalPages)
                    setTotalItems(response.data.data.totalItems);
                    setNextPage(response.data.data.nextPage);
                    setPreviousPage(response.data.data.previousPage);
                    setCurrentPage(response.data.data.currentPage);

                    setLoaderOption(false);
                }
                else {
                    console.error('API Response Error:', response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, 'error')
                }
            } catch (error) {
                console.error('Error fetching data:', JSON.stringify(error));
                setLoaderOption(false);
                openPopup("Requested Data Not Found / 404", 'warn')
            }
            //  finally {
            //     setLoaderOption(false);
            // }
        }
    };

    const handlePageChange = async (newPageNo, newPageSize) => {
        // setPageNo(newPageNo);
        // setPageSize(newPageSize);
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            // console.log(JSON.stringify(authUser.headers))
            // console.log(`${getUserListForCallAvailabilityAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`)
            try {
                const response = await axios.get(
                    `${getUserListForCallAvailabilityAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg === "Success") {
                    setData(response.data.data.items);
                    setTotalPages(response.data.data.totalPages)
                    setTotalItems(response.data.data.totalItems);
                    setNextPage(response.data.data.nextPage);
                    setPreviousPage(response.data.data.previousPage);
                    setCurrentPage(response.data.data.currentPage);

                    setLoaderOption(false);
                }
                else {
                    console.error('API Response Error:', response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, 'error')
                }
            } catch (error) {
                console.error('Error fetching data:', JSON.stringify(error));
                setLoaderOption(false);
                openPopup("Requested Data Not Found / 404", 'warn')
            }
            //  finally {
            //     setLoaderOption(false);
            // }
        }
    };


    if (!canRead) {
        return (
            <>
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Cold Calls" breadcrumbItem="Upload Cold Calls" />
                            <CantAccessPage />
                        </Container>
                    </div>
                </React.Fragment>
            </>
        )
    }
    else {
        if (loaderOption == true) {
            return (
                <>
                    <Loader />
                </>
            )
        }
        else {
            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Users" breadcrumbItem="Call Availability" />
                            <Card>
                                <CardBody>
                                    {data && (
                                        <div className='mt-3'>
                                            {/* <div className="d-flex align-items-center justify-content-end">
                                                <div className="flex-shrink-0">
                                                    <Link
                                                        to="#"
                                                        // onClick={() => setModal(true)}
                                                        className="btn btn-primary me-1"
                                                    >
                                                        Export Excel
                                                    </Link>
                                                </div>
                                            </div> */}
                                            <TableContainer
                                                columns={columns}
                                                data={data || []}
                                                isGlobalFilter={true}
                                                isPagination={true}
                                                SearchPlaceholder="Search..."
                                                isCustomPageSize={true}
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                pagination="pagination"
                                                getRowProps={row => ({
                                                    className: `${row.original.isRecAvailable === 0 ? "is-receivable" : ""
                                                        }`,
                                                })}
                                                onPageChange={handlePageChange} // Pass page change handler
                                                onPageSizeChange={handlePageChange} // Pass page size change handler
                                                pageSize={pageSize}
                                                setPageSize={setPageSize}
                                                totalPages={totalPages}
                                                totalItems={totalItems}
                                                tableNextPage={nextPage}
                                                tablePreviousPage={previousPage}
                                                tableCurrentPage={currentPage}
                                                customePageSize={customePageSize}
                                            />

                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Container>
                    </div>
                    {/* <ToastContainer position="top-right" theme="colored" /> */}

                    {isPopupVisible && (
                        <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                    )}
                </React.Fragment>
            )
        }
    }
}

CallAvailability.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(CallAvailability);
